import React, { Component } from "react";

import { BASE_ZINDEX } from "../popup-factory";

class Overlay extends Component {
  render() {
    const { popups, popupBaseZIndex = BASE_ZINDEX } = this.props;
    if (popups.length) {
      const style = {
        display: "block",
        overflow: "hidden",
        zIndex: popupBaseZIndex + popups.length - 2,
      };
      return (
        <div
          className="reveal-overlay"
          tabIndex="-1"
          aria-hidden="true"
          style={style}
        ></div>
      );
    }
    return null;
  }
}

export default Overlay;
